import { GenericCrudPage } from '@/components/GenericCrudPage';
import { faqConfig } from '@/pages/configs';

export default function FaqPage() {
  return <GenericCrudPage config={faqConfig} />;
}
